<template>
  <div class="block-wrapper" :class="[widthClass, { 'is-highlighted': highlighted }]"
    :data-block-type="block.type">
    <component :is="blockComponent" v-if="blockComponent" :data="block.data" :preview="preview" v-bind="extraProps" />
    <div v-else class="block-error">
      <p>Unknown block type: {{ block.type }}</p>
    </div>
  </div>
</template>

<script>
import TextBlock from './TextBlock.vue'
import ImageBlock from './ImageBlock.vue'
import SpacerBlock from './SpacerBlock.vue'
import ButtonBlock from './ButtonBlock.vue'
import GalleryBlock from './GalleryBlock.vue'
import TimelineBlock from './TimelineBlock.vue'
import DocumentBlock from './DocumentBlock.vue'
import ContactBlock from './ContactBlock.vue'
import VideoBlock from './VideoBlock.vue'
import HeadingBlock from './HeadingBlock.vue'
import ColumnsBlock from './ColumnsBlock.vue'

// Block type to component mapping
const BLOCK_COMPONENTS = {
  text: TextBlock,
  image: ImageBlock,
  spacer: SpacerBlock,
  button: ButtonBlock,
  gallery: GalleryBlock,
  timeline: TimelineBlock,
  document: DocumentBlock,
  contact: ContactBlock,
  video: VideoBlock,
  heading: HeadingBlock,
  columns: ColumnsBlock
}

export default {
  name: 'BlockRenderer',
  components: {
    TextBlock,
    ImageBlock,
    SpacerBlock,
    ButtonBlock,
    GalleryBlock,
    TimelineBlock,
    DocumentBlock,
    ContactBlock,
    VideoBlock,
    HeadingBlock,
    ColumnsBlock
  },
  props: {
    block: {
      type: Object,
      required: true,
      validator: (value) => {
        return value.type !== undefined && value.data !== undefined && value.data !== null
      }
    },
    preview: {
      type: Boolean,
      default: false
    },
    // Editor only: this block's entry is hovered.
    highlighted: {
      type: Boolean,
      default: false
    },
    // True for the first image-bearing blocks on the page - lets their images load eagerly.
    eager: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    blockComponent() {
      return BLOCK_COMPONENTS[this.block.type] || null
    },
    widthClass() {
      if (this.block.type === 'text' && this.block.data?.containerWidth === 'compact') return 'block-width-compact'
      return 'block-width-content'
    },
    // Only ImageBlock and ColumnsBlock (which forwards to its image slots) consume
    // `eager`; don't leak the attribute onto other block types.
    extraProps() {
      const consumesEager = this.block.type === 'image' || this.block.type === 'columns'
      return consumesEager ? { eager: this.eager } : {}
    }
  }
}
</script>

<style scoped>
.block-wrapper {
  margin-bottom: 2rem;

  &:last-child {
    margin-bottom: 0;
  }
}

.block-width-content {
  max-width: 960px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
}

.block-width-compact {
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
}

.block-error {
  padding: 20px;
  background-color: var(--color-red);
  border: 1px solid var(--color-red);
  border-radius: var(--radius);
  color: var(--color-dark-red);
  text-align: center;

  p {
    margin: 0;
  }
}
</style>
